import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ButtonModule } from '@openng/optimus-ui/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';

export interface DialogOptions {
  title: string;
  content: string;
  buttonText?: {
    ok: string;
    cancel: string;
  };
}

@Component({
  selector: 'core-confirmation-dialog',
  imports: [MatDialogModule, ButtonModule],
  template: `<ng-container>
    <div class="p-4">
      <div data-testid="confirmationTitle" mat-dialog-title>
        {{ options.title }}
      </div>
      <div data-testid="confirmationContent" mat-dialog-content>
        {{ options.content }}
      </div>
      <div class="flex justify-end" mat-dialog-actions>
        <p-button
          class="text-sm"
          (click)="onOk()"
          data-testid="confirmationOKBtn"
          [label]="options.buttonText?.ok ?? 'OK'"
        />
        <p-button
          class="text-sm"
          (click)="onCancel()"
          data-testid="confirmationCancelBtn"
          severity="secondary"
          [outlined]="true"
          cdkFocusInitial
          i18n-label="@@alert-confirmation-btn-cancel"
          [label]="options.buttonText?.cancel ?? 'Cancel'"
        />
      </div>
    </div>
  </ng-container>`,
  styles: [
    `
      .mdc-dialog__title {
        @apply pl-2 pt-0;
      }
      .mdc-dialog__content {
        @apply pl-4;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationDialogComponent {
  private readonly dialogRef =
    inject<MatDialogRef<ConfirmationDialogComponent>>(MatDialogRef);
  protected options = inject<DialogOptions>(MAT_DIALOG_DATA);

  public constructor() {
    const dialogRef = this.dialogRef;

    dialogRef.disableClose = true;
  }

  protected onOk() {
    this.dialogRef.close(true);
  }

  protected onCancel() {
    this.dialogRef.close(false);
  }
}
